import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  // console.log("checking data in product", fetchData);

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((order, index) => {
        // console.log("order", order);

        // Extract Customer details
        const customer = order.Customer || {};
        const orderPawns = order.order_pawns || [];
        const pawnTransactions = order.pawn_transactions || [];

        // Format each product within the order_pawns
        const formattedOrderPawns = orderPawns.map((pawn) => {
          const product = pawn.Product || {}; // Extract product details from each pawn
          // const picture = product.Picture || {}; // Extract product details from each pawn

          return {
            id: pawn.id || "",
            total_month: pawn.total_month || 0,
            interest_rate: pawn.interest_rate || 0,
            amount: pawn.amount || 0,
            pawn_amount: pawn.pawn_amount || 0,
            pawn_price: pawn.pawn_price || 0,
            status_id: pawn.status_id || "",
            order_id: pawn.order_id || "",
            due_date: pawn.due_date
              ? moment(pawn.due_date).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
              : "",
            product_id: product.product_id || "",
            total_amount: product.total_amount || "",
            total_price: product.total_price || "",
            product_name: product.product_name || "",
            product_price: product.price || "",
            category_id: product.category_id || "",
            product_code: product.product_code || "",
            detail: product.detail || "",
            blemishes: product.blemishes || "",
            notes: product.notes || "",
            size: product.size || "",
            product_code_com: product.product_code_com || "",
            pictures: Array.isArray(product.Pictures)
              ? product.Pictures.map((picture) => ({
                  id: picture.id,
                  picture: picture.pic
                    .split("http")
                    .filter(Boolean)
                    .map((url) => `http${url.trim()}`),
                }))
              : [], // Ensure pictures is always an array
          };
        });

        // Format pawn transactions
        const formattedPawnTransactions = pawnTransactions.map(
          (transaction) => ({
            id: transaction.id || "",
            month: transaction.month || 0,
            payment_date: transaction.payment_date
              ? moment(transaction.payment_date).format(
                  "DD/MM/YYYY\n เวลา HH:mm:ss น."
                )
              : "",
            payment_status: transaction.payment_status || "",
            order_pawn_id: transaction.order_pawn_id || "",
            due_date: transaction.due_date
              ? moment(transaction.due_date).format(
                  "DD/MM/YYYY\n เวลา HH:mm:ss น."
                )
              : "",
            payment_method: transaction.payment_method || "",
            confirm_image: transaction.confirm_image || "",
            description: transaction.description || "",
          })
        );

        // Map data to the desired format
        const row = {
          id: order.id || index,
          order_code: order.order_code || "", // Provide default value
          qrcode: order.qrcode || "", // Provide default value
          company_id: order.company_id || "", // Provide default value
          order_status: order.order_status || "", // Provide default value
          created_date: order.created_at
            ? moment(order.created_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          updated_date: order.updated_at
            ? moment(order.updated_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          customer_name: customer.name || "",
          idcard: customer.idcard || "",
          phonenumber: customer.phonenumber || "",
          address: customer.address || "",
          prefix: customer.prefix || "",
          nationality: customer.nationality || "",
          customer_image: customer.image || "",
          order_pawns: formattedOrderPawns, // Include formatted products
          order_due_date: formattedOrderPawns[0]?.due_date || [],
          picture:
            formattedOrderPawns.length > 0 &&
            formattedOrderPawns[0].pictures.length > 0
              ? formattedOrderPawns[0].pictures
              : [], // กรณีที่ไม่มีข้อมูล
          pawn_transactions: formattedPawnTransactions, // Include formatted transactions
          pawn_price: formattedOrderPawns.reduce(
            (total, item) => total + (item.pawn_price || 0),
            0
          ),
        };

        // console.log("row", row);

        rows.push(row);
      });

      console.log("256325632563", rows);
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
